import { AnyAction } from 'redux'
import { IUserState } from '~/shared/store/types'

import {
  SET_STATUS,
  SET_USER_ACCOUNT_STATUS,
  SET_UTM_TAGS,
  SET_UUID,
  UPDATE_USER_CONFIG,
} from './actionTypes'

const initState: IUserState = {
  uuid: '',
  status: null,
  utmTags: null,
  accountStatus: {
    existingUuid: '',
    hasAccessToApp: false,
    hasAccount: null,
  },
}

export function userReducer(
  state: IUserState = initState,
  { type, payload = null }: AnyAction,
): IUserState {
  switch (type) {
    case SET_UUID: {
      return {
        ...state,
        uuid: payload,
      }
    }
    case SET_STATUS: {
      return {
        ...state,
        status: payload,
      }
    }
    case SET_UTM_TAGS: {
      return {
        ...state,
        utmTags: payload,
      }
    }
    case UPDATE_USER_CONFIG: {
      return {
        ...state,
        ...(state.status && {
          status: {
            ...state.status,
            config: {
              ...state.status.config,
              ...payload,
            },
          },
        }),
      }
    }
    case SET_USER_ACCOUNT_STATUS: {
      return {
        ...state,
        accountStatus: {
          existingUuid: payload.existingUuid,
          hasAccount: payload.hasAccount,
          hasAccessToApp: payload.hasAccessToApp,
        },
      }
    }
    default:
      return state
  }
}
